
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"12","cy":"12","r":"12","fill":"#F8F9FB"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.743 6.828l-.646.647L11.622 12l-4.525 4.526.646.646 4.526-4.526 4.525 4.526.647-.646L12.915 12l4.526-4.525-.647-.647-4.525 4.526-4.526-4.526z","fill":"#424A4D"}})])
          )
        }
      }
    